import { render, staticRenderFns } from "./pintuan-list.vue?vue&type=template&id=94d6f818&scoped=true&"
import script from "./pintuan-list.vue?vue&type=script&lang=ts&"
export * from "./pintuan-list.vue?vue&type=script&lang=ts&"
import style0 from "./pintuan-list.vue?vue&type=style&index=0&id=94d6f818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d6f818",
  null
  
)

export default component.exports